import { html, nothing } from "lit";
import {
  deriveChatRenderState,
  renderChatFrame,
  renderWelcomeState,
  type ChatProps,
} from "./chat.ts";
import { renderChatRichTimeline } from "./chat-rich-timeline.ts";

function renderRichLoadingSkeleton() {
  return html`
    <div class="chat-loading-skeleton chat-rich-loading-skeleton" aria-label="Loading chat">
      <div class="chat-rich-loading-skeleton__group">
        <div class="skeleton skeleton-line skeleton-line--short"></div>
        <div class="chat-rich-loading-skeleton__bubble">
          <div class="skeleton skeleton-line skeleton-line--long" style="margin-bottom: 8px"></div>
          <div class="skeleton skeleton-line skeleton-line--medium" style="margin-bottom: 8px"></div>
          <div class="skeleton skeleton-line skeleton-line--short"></div>
        </div>
      </div>
      <div class="chat-rich-loading-skeleton__group chat-rich-loading-skeleton__group--user">
        <div class="skeleton skeleton-line skeleton-line--short"></div>
        <div class="chat-rich-loading-skeleton__bubble chat-rich-loading-skeleton__bubble--user">
          <div class="skeleton skeleton-line skeleton-line--medium"></div>
        </div>
      </div>
    </div>
  `;
}

export function renderChatRich(props: ChatProps) {
  const state = deriveChatRenderState(props);
  const thread = html`
    <div class="chat-thread chat-rich-thread" role="log" aria-live="polite" @scroll=${props.onChatScroll}>
      <div class="chat-thread-inner chat-rich-thread__inner">
        ${props.loading ? renderRichLoadingSkeleton() : nothing}
        ${state.isEmpty
          ? state.searchOpen
            ? html`<div class="agent-chat__empty">No matching messages</div>`
            : renderWelcomeState(props)
          : renderChatRichTimeline(state.chatItems, props, state)}
      </div>
    </div>
  `;
  return renderChatFrame(props, state, thread, { variantClass: "chat-rich-view" });
}
